import { http } from '../../../../api/axios';
import { shopPrefix } from '../../../../config';

export const apiChangeReserveReportSettings = (message: string) => {
    return http.post(`${shopPrefix}/v2/reservelist/defaultsetting/support`, { message });
};
